import React, { useEffect, useRef, useState } from 'react';

import SearchTopbar from './SearchTopbar';

import { useTranslation } from 'react-i18next';
import { CustomSearchDetail } from '../../components';
import AuthService from '../../security/AuthService';
import SearchFooter from './SearchFooter';
import { Toast } from 'reactstrap';
import ExhibitionService from '../../service/ExhibitionService';
import EventBus from "../../common/EventBus";
import { useParams, useSearchParams } from 'react-router-dom';


export const Search = (props) => {
    const { t } = useTranslation();

    const toast = useRef(null);

    let [searchParams, setSearchParams] = useSearchParams();
    const[searchText, setSearchText] = useState(searchParams.get("searchText"));
    const[companyCode, setCompanyCode] = useState(searchParams.get("companyCode"));
    const[searchType,setSearchType ]=useState(searchParams.get("searchType"));

    console.log("Search props", props ," use params:",searchText, companyCode,searchType);


    useEffect(() => {

    }, []);

   

    return (

        <div className='root-profile' style={{ paddingBottom: 70 }}>
            <Toast ref={toast} />

            <div className="grid grid-nogutter profile-landing-main text-800" >

                <SearchTopbar {...props} toast={toast} />

                <div >

                    <CustomSearchDetail {...props} toast={toast} companyCode={companyCode} searchText={searchText} searchType={searchType} onLoad={true} ></CustomSearchDetail>
                    
                </div>


            </div>


            <SearchFooter {...props}></SearchFooter>
        </div>

    );
};

